import { postAlipayHKDebugLog } from "@/utils/alipayhkMiniProgramBridge";

function isAlipayHKMiniappDebugTarget(config = {}) {
  if (process.server) {
    return false;
  }

  const userAgent = navigator.userAgent || "";
  const isAlipayHK =
    userAgent.indexOf("AlipayHK") > -1 ||
    userAgent.indexOf("AlipayClientHK") > -1 ||
    userAgent.indexOf("MiniProgramStudio") > -1;

  if (!isAlipayHK) {
    return false;
  }

  const url = config.url || "";
  return /\/api\/(orders|takings)\//.test(url);
}

function summarizeAxiosConfig(config = {}) {
  return {
    method: config.method,
    baseURL: config.baseURL,
    url: config.url,
    data: config.data,
    params: config.params,
  };
}

function logAlipayHKPaymentApi(level, stage, context) {
  postAlipayHKDebugLog("AlipayHKPaymentApi", level, stage, context);
}

export default function ({$axios, store, redirect, app}) {
  $axios.setHeader("X-Requested-With", "XMLHttpRequest");

  if (process.server) {
    $axios.setHeader("accept-encoding", "gzip");
    $axios.setHeader("cf-connecting-ip", "");
  }

  $axios.onError((error) => {
    const response = error.response;
    const config = response?.config || error.config || {};

    if (isAlipayHKMiniappDebugTarget(config)) {
      logAlipayHKPaymentApi("error", "response_error", {
        request: summarizeAxiosConfig(config),
        status: response?.status,
        response: response?.data,
        message: error.message,
      });
    }

    if (!response) {
      return Promise.reject(error);
    }

    const {method, url, baseURL} = response.config;
    // store.dispatch('load/unsetLoading', `${url.replace(baseURL, '')}-${method}`)
    if (response.status === 422) {
      store.dispatch("validation/setErrors", response.data.errors);
    }

    if (response.status === 401) {
      store.dispatch("me/logout");
      return false;
    }

    if (response.status == 403 || response.status == 404) {
      redirect({name: "404", params: {...response}});
      return false;
    }

    return Promise.reject(error);
  });

  $axios.onRequest((config) => {
    const {method, url, headers} = config;
    // store.dispatch('load/setLoading', `${url}-${method}`)
    // headers['Content-Type'] = 'application/json';
    // headers['Access-Control-Allow-Origin'] = "*";
    store.dispatch("validation/clearErrors");

    // get the current locale
    const locale = store.$i18n.locale;
    headers["Accept-Locale"] = locale;

    const appWebViewToken = app.$cookies.get("gm_app_webview_token");
    if (appWebViewToken) {
      headers["X-Gamemaster-App-WebView-Token"] = appWebViewToken;
    }

    if (isAlipayHKMiniappDebugTarget(config)) {
      logAlipayHKPaymentApi("info", "request", {
        request: summarizeAxiosConfig(config),
        locale,
      });
    }
  });

  $axios.onResponse(({config, status, data}) => {
    // const {method, url, baseURL} = config
    // store.dispatch('load/unsetLoading', `${url.replace(baseURL, '')}-${method}`)
    if (isAlipayHKMiniappDebugTarget(config)) {
      logAlipayHKPaymentApi("info", "response", {
        request: summarizeAxiosConfig(config),
        status,
        response: data,
      });
    }
  });
}
